import React from 'react';
import PropTypes from 'prop-types';
import { at } from 'lodash';
import { useField } from 'formik';
import {
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  FormHelperText
} from '@material-ui/core';





function SelectField(props) {
  const { label, data, isMulti = false, defaultCurrency,...rest } = props;
  const [field, meta] = useField(props);
  const { value: selectedValue } = field;
  const [touched, error] = at(meta, 'touched', 'error');
  const isError = touched && error && true;

  function _renderHelperText() {
    if (isError) {
      return <FormHelperText>{error}</FormHelperText>;
    }
  }

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 10;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

  return ( <FormControl {...rest} error={isError} variant="outlined">
      <InputLabel>{label}</InputLabel>
      <Select multiple={isMulti} {...field} value={selectedValue ? selectedValue : isMulti ? [] : ""}  MenuProps={MenuProps}>
        <MenuItem value="" disabled>
            Select {label}
        </MenuItem>
        {data.map((item, index) => (
          <MenuItem key={index} value={item.value} disabled={item.value === defaultCurrency}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
      {_renderHelperText()}
    </FormControl>
  );
}

SelectField.defaultProps = {
  data: []
};

SelectField.propTypes = {
  data: PropTypes.array.isRequired
};

export default SelectField;
